import { nriPageFooterData, nriWhatsappUrl, nriRahulPhoto } from "../../data/nriTaxData";
import { Instagram, Youtube, Linkedin, Mail, ArrowUpRight } from "lucide-react";

export const NriPageFooter = () => {
  return (
    <footer className="relative py-14" style={{ background: "#252422" }}>
      <div className="absolute top-0 left-0 right-0 h-px bg-[#3f4816]/30" />
      <div className="max-w-[87.5rem] mx-auto px-10">
        {/* Social Proof Line */}
        <div className="mb-10 pb-8 border-b border-[#3f4816]/15 text-center">
          <p
            className="text-[#888680] text-sm"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            {nriPageFooterData.socialProofLine}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div className="flex items-start gap-3">
            <img
              src={nriRahulPhoto}
              alt="CA Rahul Taneja"
              className="w-11 h-11 rounded-full object-cover object-top border border-[#3f4816]/30"
            />
            <div>
              <p
                className="text-[#dfddd6] text-sm font-bold mb-0.5"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                {nriPageFooterData.name}
              </p>
              <p
                className="text-[#888680] text-xs"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                {nriPageFooterData.credentials}
              </p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <p
              className="text-[#dfddd6] text-sm mb-1"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {nriPageFooterData.location}
            </p>
            <p
              className="text-[#888680] text-xs mb-3"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {nriPageFooterData.website} · {nriPageFooterData.handle}
            </p>
            <a
              href={nriWhatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#888680] text-xs transition-colors hover:text-[#25D366]"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              WhatsApp: {nriPageFooterData.whatsapp}
            </a>
          </div>

          {/* Social */}
          <div>
            <p
              className="text-[#888680] text-xs font-semibold mb-3 uppercase tracking-wider"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {nriPageFooterData.handle}
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              <a
                href={nriPageFooterData.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 border border-[#3f4816]/30 rounded-full flex items-center justify-center text-[#888680] transition-all duration-300 hover:border-[#3f4816]/60 hover:text-[#dfddd6]"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href={nriPageFooterData.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 border border-[#3f4816]/30 rounded-full flex items-center justify-center text-[#888680] transition-all duration-300 hover:border-[#3f4816]/60 hover:text-[#dfddd6]"
                aria-label="YouTube"
              >
                <Youtube size={16} />
              </a>
              <a
                href={nriPageFooterData.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 border border-[#3f4816]/30 rounded-full flex items-center justify-center text-[#888680] transition-all duration-300 hover:border-[#3f4816]/60 hover:text-[#dfddd6]"
                aria-label="LinkedIn"
              >
                <Linkedin size={16} />
              </a>
            </div>
          </div>
        </div>

        {/* Legal Disclaimer + Bottom Bar */}
        <div className="pt-6 border-t border-[#3f4816]/20">
          <p
            className="text-[#888680]/40 text-[11px] leading-relaxed mb-4 max-w-4xl"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            {nriPageFooterData.disclaimer}
          </p>
          <div className="flex flex-col md:flex-row items-center justify-between gap-3">
            <p
              className="text-[#888680]/40 text-xs"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              &copy; {new Date().getFullYear()} CA Rahul Taneja. All rights reserved.
            </p>
            <a
              href="#nri-hero"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="text-[#888680]/40 text-xs flex items-center gap-1 transition-colors hover:text-[#dfddd6]"
            >
              Back to top <ArrowUpRight size={10} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
